export const getTableRowId = (id: string) => `tableRow-${id}`;
